import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowUpRight, LogOut, Menu, X } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const links = [
    ['/leistungen', 'Leistungen & Preise'],
    ['/gameserver-leihen', 'Gameserver leihen'],
    ['/tools', 'Nützliche Tools'],
    ['/#seo', 'SEO'],
    ['/forum', 'Forum'],
    ['/software', 'Produkte & Mods'],
    ['/ueber-uns', 'Über uns'],
];

export function Navbar() {
    const [open, setOpen] = useState(false);
    const [compact, setCompact] = useState(false);
    const { isAuthenticated, isStaff, logout } = useAuth();
    const { pathname, hash } = useLocation();

    useEffect(() => {
        const onScroll = () => setCompact(window.scrollY > 24);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => setOpen(false), [pathname, hash]);

    const isActive = href => href.includes('#')
        ? pathname === (href.split('#')[0] || '/') && hash === `#${href.split('#')[1]}`
        : pathname.startsWith(href);

    return (
        <header className={`cl-nav ${compact ? 'is-compact' : ''}`} data-testid="navbar">
            <Link to="/" className="cl-logo" aria-label="Core Labs Startseite">
                <img className="cl-brand-logo" src="/core-labs-logo-transparent.png" alt="" aria-hidden="true" />
            </Link>
            <nav className="cl-nav-links" aria-label="Hauptnavigation">
                {links.map(([href, label]) => {
                    const active = isActive(href);
                    return <Link key={href} className={active ? 'active' : ''} aria-current={active ? 'page' : undefined} to={href}>{label}</Link>;
                })}
            </nav>
            <div className="cl-nav-actions">
                {isAuthenticated ? (
                    <>
                        <Link className="cl-account-link" to="/portal">{isStaff ? 'Kundenansicht' : 'Kundenportal'}</Link>
                        {isStaff && <Link className="cl-account-link" to="/admin">CMS</Link>}
                        <button type="button" className="cl-icon-button" onClick={logout} aria-label="Abmelden"><LogOut aria-hidden="true" /></button>
                    </>
                ) : <Link className="cl-account-link" to="/login">Kundenportal</Link>}
                <Link className="cl-nav-cta" to="/kontakt">Webprojekt anfragen <ArrowUpRight /></Link>
                <button type="button" className="cl-menu-button" onClick={() => setOpen(!open)} aria-expanded={open} aria-controls="mobile-navigation" aria-label={open ? 'Menü schließen' : 'Menü öffnen'}>
                    {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
                </button>
            </div>
            {open && (
                <nav id="mobile-navigation" className="cl-mobile-nav" aria-label="Mobile Navigation">
                    {links.map(([href, label]) => {
                        const active = isActive(href);
                        return <Link key={href} aria-current={active ? 'page' : undefined} to={href}>{label}<ArrowUpRight /></Link>;
                    })}
                    <Link to="/kontakt">Webprojekt anfragen<ArrowUpRight /></Link>
                    {isAuthenticated ? (
                        <>
                            <Link to="/portal">{isStaff ? 'Kundenansicht' : 'Kundenportal'}<ArrowUpRight /></Link>
                            {isStaff && <Link to="/admin">CMS<ArrowUpRight /></Link>}
                        </>
                    ) : <Link to="/login">Kundenportal<ArrowUpRight /></Link>}
                </nav>
            )}
        </header>
    );
}

export default Navbar;
